import { h } from 'preact';

export default ({ className, color = '#000000' }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={color}>
    <path d="M 8 3 L 14 12 L 8 21 L 12 21 L 18 12 L 12 3 L 8 3 z" fill={color} />
  </svg>
);
